import { c as _c } from "react/compiler-runtime";
import { CreditViewMode } from "@custom-types/credit-types";
import { Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { CreditsDialog } from "@pages/settings/subscription-settings/credits/credits-dialog";
import { NewCreditIndication } from "@pages/settings/subscription-settings/credits/new-credit-indication";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { formatNumber } from "@utils/data-display";
/**
 * Displays the user's credit(token) balance along with an action button to view transactions.
 *
 * This component shows the current credit balance and provides a button to navigate
 * to the credit transactions page. When the button is clicked, an event is tracked
 * for analytics purposes.
 */
export function CreditsBalanceItem(t0) {
  const $ = _c(12);
  const {
    creditBalance
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexDirection: "row",
      alignItems: "start"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== creditBalance) {
    t3 = formatNumber(creditBalance);
    $[2] = creditBalance;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Text variant="bodyL" data-testid="credits-balance-item-balance"><var>{t3}</var> {CREDITS_DISPLAY_NAME}</Text>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NewCreditIndication />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <Stack sx={t2}>{t4}{t5}</Stack>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CreditsDialog buttonLabel="View transactions" initialViewMode={CreditViewMode.transaction} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <Stack sx={t1}>{t6}{t7}</Stack>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}